export default __webpack_public_path__ + "static/media/app_download_round_shape.28871db6.png";